/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.updatePhoneLogin = function() {
  let p = $('#phone_input').val();
  const e = $('#extension_input').val();
  p = p.replace(/\D/g,'');
  if (p.match(/[2-9]\d{2}[2-9]\d{6}/) && (p.length === 10)) {
    p = '+1' + p;
  } else {
    p = '+' + p;
  }
  if (e.length > 0) {
    p += '_' + e;
  }
  $('#hidden_login').val(p);
  if ($('input[name="user[owner_resident]"]:checked').val() === "visitor") {
    $("#resident-info").hide();
  } else {
    $("#visitor-info").hide();
  }
  return $('input[name="user[owner_resident]"]').change(function() {
    if ((this.value === "owner") || (this.value === "renter")) {
      $("#resident-info").show();
      $("#visitor-info").hide();
    }
    if (this.value === "visitor") {
      $("#resident-info").hide();
      return $("#visitor-info").show();
    }
  });
};

root.showPassword = () => $('#show-password').click(function(event) {
  event.stopPropagation();
  const $passwordInput = $('#login-password');
  if ($passwordInput.attr('type') === 'password') {
    return $passwordInput.attr('type', 'text');
  } else {
    return $passwordInput.attr('type', 'password');
  }
});

root.checkCapsLock = () => $('input.email, input.password').keydown(function(event) {
  event = event.originalEvent;
  const capsLock = event.getModifierState && event.getModifierState('CapsLock');
  if (capsLock) {
    if ($('small.error').length === 0) {
      $(this).parent().addClass('error');
      return $(this).parent().append("<small class='error'>CapsLock is on</small>");
    }
   } else {
     $(this).parent().removeClass('error');
     return $(this).parent().find('small.error').remove();
   }
});

/*
$(function() {
  $('#phone_input').keyup(() => updatePhoneLogin());
  $('#extension_input').keyup(() => updatePhoneLogin());
  $("#log-in-form").on("opened", function() {
    $(this).foundation("section", "reflow");
    return $('#email').find('p.title a').click();
  });
  if ($('#show-password').length) {
    showPassword();
  }
  if ($('#new_session')) {
    return checkCapsLock();
  }
});
*/

function initLogInOnLoad() {
    $('#phone_input').keyup(() => updatePhoneLogin());
  $('#extension_input').keyup(() => updatePhoneLogin());
  $("#log-in-form").on("opened", function() {
    $(this).foundation("section", "reflow");
    return $('#email').find('p.title a').click();
  });
  if ($('#show-password').length) {
    showPassword();
  }
  if ($('#new_session')) {
    return checkCapsLock();
  }
}

document.addEventListener('turbo:load', initLogInOnLoad);
